
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
import { IWykrojnikRow } from "../IWykrojnikRow";

import WykrojnikTitleVue from "../WykrojnikTitleVue.vue";
import WykrojnikRowVue from "../WykrojnikRowVue.vue";
import WykrojnikRowEditVue from "../WykrojnikRowEditVue.vue";
import { IWykrojnikParams } from "../params/IWykrojnikParams";
import { WykrojnikiCostSvc } from "./WykrojnikiCostSvc";
import { WykrojnikRow } from "../WykrojnikRow";
import { Next, Route } from 'vue-router';
import { WykrojnikSvc } from "../WykrojnikSvc";
import { wykrojnik_api } from "../IWykrojnikSvc";

import  CostVue from "./CostVue.vue"

import  ButtonVue from "@/lib/Button.vue";
@Component({
        async beforeRouteEnter(to: Route, from: Route, next: Next<WykrojnikiVue>) {
          console.log(to.params.id)
            next((vm: WykrojnikiVue) => { vm.tree_id = to.params.id; console.log(vm.tree_id) });
        },
      components: { WykrojnikTitleVue, WykrojnikRowVue, WykrojnikRowEditVue, ButtonVue, CostVue }
})

export default class WykrojnikiVue extends Vue {
  wykrojniki: IWykrojnikRow[] = [];
  key:number=0;
  tree_id:any;

  dbgp_key=0;
  dbgz_key=0;
  dbgk_key=0;



  async mounted() {
   console.log("mounted")
    bus.register("wykrojnik_selected_clicked", this.wykrojnik_selected_clicked)
    bus.register("wykrojnik_manual_changed", this.wykrojnik_manual_changed)
 
    await this.refresh()
 
  }

  async refresh() {

    //const wykrojniki:IWykrojnikRow[]|undefined = await new WykrojnikiCostSvc().get_wykrojniki_z_kosztem(this.tree_id)
    const wykrojniki:IWykrojnikRow[]|undefined = await new WykrojnikiCostSvc().get_wykrojniki_z_kosztem_detailed(this.tree_id)


    if (!wykrojniki) return;

    this.wykrojniki = wykrojniki;
    this.key++;
  }
  beforeDestroy() {
      bus.remove("wykrojnik_selected_clicked", this.wykrojnik_selected_clicked)
      bus.remove("wykrojnik_manual_changed", this.wykrojnik_manual_changed)
  }

async wykrojnik_selected_clicked(e:any) {
    const wykrojnik_selected:IWykrojnikRow=e.detail;
    wykrojnik_selected.parent_id = this.tree_id;
    wykrojnik_selected._id       = this.tree_id;

    //alert("Save nr:"+wykrojnik_selected.numer+" "+wykrojnik_selected._id)
    
    const wykrojnik_selected_saved = await new WykrojnikSvc().save_selected_wykrojnik_for_tree(wykrojnik_selected)

    console.log("saving",wykrojnik_selected_saved)
    if (wykrojnik_selected_saved) {
      bus.fire("hilight_wykrojnik",wykrojnik_selected_saved)
    }
  }

async wykrojnik_manual_changed(e:any) {
    const wykrojnik_changed:IWykrojnikRow=e.detail;
    wykrojnik_changed.parent_id = this.tree_id;
    console.log("saving",wykrojnik_changed)
    const wykrojnik_changed_saved = await new WykrojnikSvc().save_manual_wykrojnik_for_tree(wykrojnik_changed)
    console.log("saving",wykrojnik_changed_saved)
    await this.refresh()
  }


  dbgp(w:any) {
    if (w._dbgp==1) w._dbgp=0;
    else w._dbgp=1;
    this.dbgp_key++
  }


  dbgz(w:any) {
    if (w._dbgz==1) w._dbgz=0;
    else w._dbgz=1;
    this.dbgz_key++
  }

  dbgk(w:any) {
    if (w._dbgk==1) w._dbgk=0;
    else w._dbgk=1;
    this.dbgk_key++
  }




}
